<script setup lang="ts">
import { Website } from "@/config";
import { createHomepageLink } from "@/router/linkFactories";
</script>

<template>
  <RouterLink :to="createHomepageLink()" class="logo">
    <img src="/images/logo-full-color.svg" :alt="Website.name" :title="$gettext('…vstup do světa sběratelů')" width="350" height="109" />
  </RouterLink>
</template>

<style lang="scss" scoped>
.logo {
  width: 90%;
  max-width: 210px;
  aspect-ratio: 350/109;
  margin: var(--spacing4x) auto var(--spacing8x) auto;
  display: block;

  @include mixins.maxScreenWidth(md) {
    max-width: 170px;
  }
  @include mixins.maxScreenWidth(sm) {
    max-width: 120px;
  }

  img {
    display: block;
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}
</style>
